/* unplugin-vue-components disabled */import { render } from "./tenant-settings.vue?vue&type=template&id=cf4b152a&scoped=true"
import script from "./tenant-settings.vue?vue&type=script&lang=js"
export * from "./tenant-settings.vue?vue&type=script&lang=js"

import "./tenant-settings.vue?vue&type=style&index=0&id=cf4b152a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf4b152a"],['__file',"src/pages/tenant/settings/tenant-settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf4b152a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf4b152a', __exports__)) {
    api.reload('cf4b152a', __exports__)
  }
  
  module.hot.accept("./tenant-settings.vue?vue&type=template&id=cf4b152a&scoped=true", () => {
    api.rerender('cf4b152a', render)
  })

}


export default __exports__